import { useState } from "react";
import { apiUrl } from "../utils/api";

export default function QuizRating({
    quizId,
    averageRating,
    ratingCount,
    userRating,
    disabled,
    text,
    onRated
}) {
    const [error, setError] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const submitRating = async (rating) => {
        setError("");
        setIsSaving(true);
        try {
            const response = await fetch(apiUrl("rate_quiz.php"), {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ quizId, rating })
            });
            const result = await response.json();
            if (!response.ok) {
                throw new Error(result.error || `Rating API returned HTTP ${response.status}`);
            }
            onRated(result);
        } catch (error) {
            console.error("Failed to rate quiz:", error);
            setError(text.ratingError);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="quiz-rating" aria-label={`${text.averageRating}: ${averageRating}`}>
            <div className="quiz-rating-stars" role="group" aria-label={text.rateQuiz}>
                {[1, 2, 3, 4, 5].map((rating) => (
                    <button
                        key={rating}
                        type="button"
                        className={`quiz-rating-star${
                            rating <= (userRating || Math.round(averageRating))
                                ? " selected"
                                : ""
                        }`}
                        aria-label={`${text.rateQuiz} ${rating}`}
                        aria-pressed={userRating === rating}
                        disabled={disabled || isSaving}
                        onClick={() => submitRating(rating)}
                    >
                        ★
                    </button>
                ))}
            </div>
            <span>
                {averageRating > 0 ? averageRating.toFixed(1) : "—"}
                {" · "}
                {ratingCount} {text.ratings}
            </span>
            {error && <span className="quiz-rating-error" role="alert">{error}</span>}
        </div>
    );
}
